export function hexToRgbA(hex, alpha) {
    const hexRegex = /^#[0-9a-fA-F]{6}$/;
    if (hex.length !== 7) {
        throw new Error('Invalid hex string length');
    }
    if (!hexRegex.test(hex)) {
        throw new Error('Invalid hex color code');
    }
    if (alpha < 0 || alpha > 1) {
        throw new Error('Invalid alpha value');
    }
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgb(${r}, ${g}, ${b})`;
}
//# sourceMappingURL=color-utils.js.map